import { render, staticRenderFns } from "./CustomizeColumnIcon.vue?vue&type=template&id=357d282f&scoped=true"
import script from "./CustomizeColumnIcon.vue?vue&type=script&lang=js"
export * from "./CustomizeColumnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357d282f",
  null
  
)

export default component.exports